import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select/dist/js/tom-select.complete.js";

// Connects to data-controller="tom-select"
export default class extends Controller {
  connect() {
    console.log("tom-select connected");

    new TomSelect(this.element, {
      plugins: ["remove_button", "clear_button"],
      maxItems: null,
      placeholder: "Select an attendee...",
      render: {
        no_results: function (data, escape) {
          return (
            '<div class="no-results">No results found for "' +
            escape(data.input) +
            '"</div>'
          );
        }
      }
    });
  }

  disconnect() {
    const tomSelect = this.element.tomselect;

    if (tomSelect) {
      tomSelect.destroy();
    }
  }
}
